import AppCard, {
  ExtendedCloudApp,
  ExtendedGlobalApp,
} from "../../Cards/AppCard";
import { CloudApp, GlobalApp } from "../../../../types/GlobalInterfaces";
import KeyFeature from "./KeyFeature";
import dayjs from "dayjs";

interface Props {
  app: CloudApp | GlobalApp;
}

const ProductDetails = ({ app }: Props) => {
  return (
    <div className="tw:flex tw:flex-col tw:gap-12 tw:mt-8">
      {app.Images && app.Images.length > 0 && (
        <div>
          <h4>At a Glance</h4>
          <div className="tw:flex tw:gap-4 tw:overflow-x-auto tw:pb-4 tw:pt-1 tw:px-1">
            {app.Images.map((image: any, i) => {
              return (
                <img
                  key={i}
                  alt={`${app?.Name || "App"} Image`}
                  src={image.PublicURL}
                  className="tw:w-88 tw:h-62 tw:rounded tw:object-contain btn-oauth"
                />
              );
            })}
          </div>
        </div>
      )}

      {app?.Description?.RichText && (
        <div>
          <h4>Description</h4>
          <div
            className="ql-editor tw:border-none tw:p-0 tw:leading-[27.2px]"
            dangerouslySetInnerHTML={{ __html: app?.Description?.RichText }}
          />
        </div>
      )}
      {app?.KeyFeatures && app?.KeyFeatures?.length > 0 && (
        <div>
          <h4>Key Features</h4>
          <div className="tw:flex tw:flex-wrap tw:w-full tw:gap-3">
            {app.KeyFeatures.map((note: any) => {
              return (
                <KeyFeature
                  key={`key-feature-${note.Title}`}
                  KeyFeature={note}
                />
              );
            })}
          </div>
        </div>
      )}

      {app?.ReleaseNotes && app?.ReleaseNotes?.length > 0 && (
        <div>
          <h4>Release Notes</h4>
          <ul className="tw:list-disc tw:pl-5">
            {app.ReleaseNotes.map((note: any, i) => {
              return (
                <li key={i} className="tw:mb-2">
                  {note.Title}
                </li>
              );
            })}
          </ul>
        </div>
      )}

      {app?.InstallationRequirements &&
        app?.InstallationRequirements?.length > 0 && (
          <div>
            <h4>Requirements</h4>
            <ul className="tw:list-disc tw:pl-5">
              {app?.InstallationRequirements?.map((requirement: any, i) => {
                return (
                  <li className="tw:mb-2" key={i}>
                    {requirement.Title}
                  </li>
                );
              })}
            </ul>
          </div>
        )}

      {app.RelatedApps && app.RelatedApps?.length && (
        <div>
          <h4>Related Producs</h4>
          <div className="tw:flex tw:flex-wrap" style={{ gap: 10 }}>
            {app.RelatedApps.map(
              (app: ExtendedCloudApp | ExtendedGlobalApp) => {
                return <AppCard app={app} isGlobalApp />;
              }
            )}
          </div>
        </div>
      )}
      <div className="tw:font-medium tw:flex tw:flex-col tw:gap-1 tw:text-sm">
        <h4>App Details</h4>
        <div>
          <span className="tw:text-dark">Created:</span>
          &nbsp;&nbsp;
          {formatDate(app.Created)}
        </div>
        <div>
          <span className="tw:text-dark">Last Updated:</span>
          &nbsp;&nbsp;
          {formatDate(app.LastUpdated)}
        </div>
        <div>
          <span className="tw:text-dark">Version:</span>
          &nbsp;&nbsp;
          {app.Version}
        </div>
      </div>
    </div>
  );
};

function formatDate(date: string | undefined) {
  if (!date) {
    return "";
  }

  return dayjs(date).format("MMMM Do, YYYY");
}

export default ProductDetails;
